module.exports = __webpack_public_path__ + "static/media/rotate-vehicle.052a6398.gif";